/* eslint-disable @typescript-eslint/no-unused-vars */

import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "../data/reducers";
// import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';

// var composeEnhancers = composeWithDevTools({
//     actionSantizer: (action) => action?.payload?.availabilities ? { ...action, availabilities: [] } : action,
//     stateSanitizer: (state) => {
//         if (Object.keys(state.availabilities.byPerson)?.length === 0) return state;
//         return state.availabilities.byPerson ? { ...state, availabilities: { byPerson: '<<LONG_BLOB>>' } } : state
//     }
// })

export default function configureSSStore() {
  return configureStore({ reducer: rootReducer });
}
